<template>
    <div>
        <Breadcrumb>
            <span v-if="post.postCategory">
                <span><router-link :to="{ path: '/' }">Početna</router-link></span>
                <span class="separetor">/</span>
                <span><router-link :to="{ name: 'category', params: { category: post.postCategoryCode } }">{{
                    post.postCategory }}</router-link></span>
                <span class="separetor">/</span>
                <span class="font-weight-bolder"><router-link
                        :to="{ name: 'category', params: { category: post.postCategoryCode, subcategory: post.postSubcategoryCode } }">{{
                            post.postSubcategory }}</router-link></span>
            </span>
        </Breadcrumb>
        <hr v-if="post.postCategoryID" class="category-line"
            v-bind:style="{ borderTop: '1.5px solid' + post.postCategoryBorderColor }" />

        <section class="has-sidebar u-padding-tb-40">

            <div class="container">
                <div id="garminAboveAd728x90"
                    v-if="(new Date().getDate() == 8 || new Date().getDate() == 15) && new Date().getMonth() + 1 == 9"
                    class="ad-728-90-above">
                </div>
                <div v-else class="ad-728-90-above">
                    <GoogleAdSense :adSlot="'1773792690'" :width="728" :height="90" />
                </div>
                <div class="row" data-sticky_parent>
                    <div class="col-lg-8 content-wrapper">
                        <div data-sticky_column>
                            <div class="m-post-content m-post-content--nyc">
                                <div class="post-top">
                                    <ul v-if="post.postCategoryID" class="categories">
                                        <li v-if="post.postSubcategoryID != 0"><router-link
                                                :to="{ name: 'category', params: { category: post.postCategoryCode, subcategory: post.postSubcategoryCode } }"
                                                v-bind:style="{ background: post.postCategoryBorderColor }">{{
                                                    post.postSubcategory }}</router-link></li>
                                        <li v-else><router-link
                                                :to="{ name: 'category', params: { category: post.postCategoryCode } }"
                                                v-bind:style="{ background: post.postCategoryBorderColor }">{{
                                                    post.postCategory }}</router-link></li>
                                    </ul>
                                    <ul v-if="post.isBreakingNews" class="categories pull-right mr-0">
                                        <li><a href="javascript:;" style="background: rgb(224, 36, 36)">Ekskluzivno</a></li>
                                    </ul>
                                    <h6 class="headline">{{ post.headline }}</h6>
                                    <h2 class="post-title">{{ post.title }}</h2>
                                    <div class="post-meta">
                                        <div class="item">
                                            <i class="fa fa-clock-o"></i>{{ post.postDate | timeAgo }}
                                        </div>
                                        <div class="item" v-if="post.isPromo">
                                            <a href="javascript:;"><i class="fa fa-user"></i>Sponzorisani članak</a>
                                        </div>
                                        <div class="item" v-if="!post.hideAuthorNick && !post.isPromo">
                                            <a href="javascript:;"><i class="fa fa-user"></i>{{ post.authorNick }}</a>
                                        </div>
                                        <!-- <div class="item">
                                        <a href="javascript:;"><i class="fa fa-eye"></i>{{ post.viewsNumber }}</a>
                                    </div> -->
                                    </div>
                                </div>
                                <div class="entry-content">
                                    <p v-if="post.intro" class="font-weight-bold mb-4">{{ post.intro }}</p>
                                </div>
                                <figure v-if="post.multimediaFiles && post.multimediaFiles.some(mf => mf.fileType !== 6)"
                                    class="mb-4 post-thumb">
                                    <vueper-slides @ready="showOrHideFractions()" lazy lazy-load-on-drag fade fractions
                                        :slideRatio="0.60" :touchable="false">
                                        <vueper-slide
                                            v-for="(photo, i) in post.multimediaFiles.filter(mf => mf.fileType !== 6)"
                                            :key="i" :image="photo.absoluteUrl">
                                            <template v-slot:loader>
                                                <span>Učitavam... </span>
                                            </template>
                                            <template v-slot:content>
                                                <a v-on:click="enlargePhoto(i)">
                                                    <div class="full-screen">
                                                    </div>
                                                </a>
                                            </template>
                                        </vueper-slide>
                                    </vueper-slides>
                                </figure>
                                <div class="entry-content">
                                    <LightBox
                                        v-if="post.multimediaFiles && post.multimediaFiles.some(mf => mf.fileType !== 6)"
                                        :media="post.multimediaFiles.filter(mf => mf.fileType !== 6).map(function (mf) { return { thumb: mf.absoluteUrl, src: mf.absoluteUrl } })"
                                        :showLightBox="false" ref="lightbox"></LightBox>
                                    <div v-if="post.videoUrl" class="videoWrapper">
                                        <youtube :video-id="this.$youtube.getIdFromUrl(post.videoUrl)" ref="youtube">
                                        </youtube>
                                    </div>
                                    <div v-if="post.multimediaFiles && post.multimediaFiles.some(mf => mf.fileType === 6)"
                                        class="audioWrapper mb-3"><audio controls>
                                            <source
                                                v-bind:src="post.multimediaFiles.find(mf => mf.fileType === 6).absoluteUrl">
                                        </audio></div>
                                    <span v-html="post.content1"></span>
                                    <p>
                                        <GoogleAdSense :adSlot="'6445172044'" :adType="'InArticle'" />
                                    </p>
                                    <span v-html="post.content2"></span>
                                    <p v-if="post.source"><strong>Izvor:</strong> {{ post.source }} </p>
                                </div>

                                <div v-if="post.tags && post.tags.length > 0" class="post-tags">
                                    <div class="tags-wrap">
                                        <router-link v-for="tag in post.tags" :key="tag.tagID" class="cat-world"
                                            :to="{ name: 'category', query: { tagId: tag.tagID } }"><i class="fa fa-tag"
                                                aria-hidden="true"></i>{{ tag.name }}</router-link>
                                    </div>
                                </div>
                                <div class="style-1">
                                    <div class="widget social">
                                        <ul class="social--color" v-if="post.postID">
                                            <li>
                                                <iframe
                                                    v-bind:src="'https://www.facebook.com/plugins/share_button.php?href=https://politicki.ba/' + post.postCategoryCode + '/' + post.searchCode + '/' + post.postID + '&layout=button_count&size=large&appId=579217629621067&width=110&height=28'"
                                                    width="85" height="28" style="border:none;" scrolling="no"
                                                    frameborder="0" allowTransparency="true"
                                                    allow="encrypted-media"></iframe>
                                            </li>
                                            <li>
                                                <iframe id="tweet-button" allowtransparency="true" frameborder="0"
                                                    scrolling="no"
                                                    v-bind:src="'https://platform.twitter.com/widgets/tweet_button.html?original_referer=https://politicki.ba/' + post.postCategoryCode + '/' + post.searchCode + '/' + post.postID + '&size=l&text=' + post.title + '&type=share&url=https://politicki.ba/' + post.postCategoryCode + '/' + post.searchCode + '/' + post.postID"
                                                    style="width:77px; height:28px;"></iframe>
                                            </li>
                                            <li v-if="post.postID">
                                                <span class="mobile">
                                                    <ShareNetwork network="whatsapp" v-bind:url="this.currentUrl"
                                                        v-bind:title="post.title" v-bind:description="post.intro">
                                                        <a class="social__whatsapp" href="javascript:;"><i
                                                                class="fa fa-whatsapp"></i></a>
                                                    </ShareNetwork>
                                                </span>
                                            </li>
                                            <li v-if="post.postID">
                                                <span class="mobile">
                                                    <ShareNetwork network="viber" v-bind:url="this.currentUrl"
                                                        v-bind:title="post.title" v-bind:description="post.intro">
                                                        <a class="social__viber" href="javascript:;"><i
                                                                class="fa fa-phone"></i></a>
                                                    </ShareNetwork>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h4>Komentari</h4>
                                        <div v-show="post.hasComments" class="fb-comments" v-bind:data-href="currentUrl"
                                            data-numposts="5" data-width="100%"></div>
                                        <span v-if="post.hasComments !== 'undefined' && post.hasComments === false">Ovaj
                                            članak nije moguće komentarisati.</span>
                                    </div>
                                </div>
                            </div>


                            <div id="garminBelowAd728x90"
                                v-if="post.similarPosts && post.similarPosts.length > 0 && (new Date().getDate() == 8 || new Date().getDate() == 15) && new Date().getMonth() + 1 == 9"
                                class="ad-728-90-below">
                            </div>
                            <div v-else-if="post.similarPosts && post.similarPosts.length > 0" class="ad-728-90-below">
                                <GoogleAdSense :adSlot="'8281520984'" :width="728" :height="90" />
                            </div>


                            <div v-if="post.similarPosts && post.similarPosts.length > 0"
                                class="posts-box has-cat u-margin-t-40">
                                <div class="posts-box__top">
                                    <h4 class="posts-box__top__title">Povezane vijesti</h4>
                                </div>

                                <div class="posts-list has-style-1">
                                    <article v-for="similarPost in post.similarPosts" :key="similarPost.postID"
                                        class="post-item cat-business post-item--style-1">
                                        <figure>
                                            <router-link
                                                :to="{ name: 'read', params: { category: similarPost.categoryCode, slug: similarPost.searchCode, id: similarPost.postID } }">
                                                <img v-lazy="similarPost.absolutePhotoUrl"
                                                    v-bind:alt="post.title"></router-link>
                                        </figure>
                                        <div class="post-content">
                                            <div class="post-category">
                                                <ul>
                                                    <li>
                                                        <router-link
                                                            :to="{ name: 'read', params: { category: similarPost.categoryCode, slug: similarPost.searchCode, id: similarPost.postID } }"
                                                            v-bind:style="{ background: similarPost.categoryBorderColor }">{{
                                                                similarPost.subcategory ? similarPost.subcategory :
                                                                similarPost.category }}</router-link>
                                                    </li>
                                                </ul>
                                            </div>
                                            <h4 class="post-title"><router-link
                                                    :to="{ name: 'read', params: { category: similarPost.categoryCode, slug: similarPost.searchCode, id: similarPost.postID } }">{{
                                                        similarPost.title }}</router-link></h4>
                                            <div class="post-meta">
                                                <i class="fa fa-clock-o"></i>{{ similarPost.postDate | date }}
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                        <div id="garminBelowAd728x90"
                            v-if="(new Date().getDate() == 8 || new Date().getDate() == 15) && new Date().getMonth() + 1 == 9"
                            class="ad-728-90-below">
                        </div>
                        <div v-else class="ad-728-90-below">
                            <GoogleAdSense :adSlot="'9548340930'" :width="728" :height="90" />
                        </div>
                    </div>

                    <div v-if="post.postCategoryID" class="col-lg-4 sidebar sidebar--right u-md-down-margin-t-40">
                        <div v-if="post.postCategoryID === 1 || post.postCategoryID === 12">
                            <Poll></Poll>
                        </div>
                        <div id="garminAboveAd300x600"
                            v-if="Math.floor(Math.random() * 10) < 8 && (new Date().getMonth() + 1 == 10 || new Date().getMonth() + 1 == 11)"
                            class="ad-300-600-sidebar-above">
                        </div>
                        <div v-if="advertisements.aboveSidebarAd_300_600 != null" class="ad-300-600-sidebar-above">
                            <a v-bind:href="advertisements.aboveSidebarAd_300_600.advertisersWebPage"
                                v-on:click="updateAdvertisementClicks(advertisements.aboveSidebarAd_300_600.advertisementID)"
                                target="_blank">
                                <img v-bind:src="advertisements.aboveSidebarAd_300_600.absolutePhotoUrl"></a>
                        </div>
                        <div v-else class="ad-300-250-sidebar-above">
                            <GoogleAdSense :adSlot="'9248640808'" :width="300" :height="250" />
                        </div>
                        <div class="side-bar__inner" data-sticky_column>
                            <app-MostRecent :postCategoryId="post.postCategoryID"
                                :postSubcategoryId="post.postSubcategoryID"
                                :postCategoryBorderColor="post.categoryBorderColor" :takeCount="6"></app-MostRecent>
                        </div>
                        <div v-if="advertisements.belowSidebarAd_300_600 != null" class="ad-300-600-sidebar-below">
                            <a v-bind:href="advertisements.belowSidebarAd_300_600.advertisersWebPage"
                                v-on:click="updateAdvertisementClicks(advertisements.belowSidebarAd_300_600.advertisementID)"
                                target="_blank">
                                <img v-bind:src="advertisements.belowSidebarAd_300_600.absolutePhotoUrl"></a>
                        </div>
                        <div v-else class="ad-300-250-sidebar-below">
                            <GoogleAdSense :adSlot="'5800667610'" :width="300" :height="250" />
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { AdvertisementsService } from '../common/api.service'
import GoogleAdSense from "../components/GoogleAdSense.vue";
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import { NewsService } from '../common/api.service'
import MostRecent from '../components/MostRecent'
import Breadcrumb from '../components/Breadcrumb'
import LightBox from 'vue-image-lightbox'
import Poll from '../components/Poll.vue'
import postscribe from 'postscribe';

require('vue-image-lightbox/dist/vue-image-lightbox.min.css')
export default {
    name: "Details",
    components: { GoogleAdSense, VueperSlides, VueperSlide, LightBox, appMostRecent: MostRecent, Poll, Breadcrumb },
    metaInfo() {
        return {
            title: this.post.title,
            meta: [
                { name: 'description', content: this.post.intro },
                { property: 'og:title', content: this.post.title },
                { property: 'og:site_name', content: 'Politicki.ba' },
                { property: 'og:description', content: this.post.intro },
                { property: 'og:url', content: this.currentUrl },
                { property: 'og:image', content: this.post.absoluteThumbnailUrl }
            ]
        }
    },
    data() {
        return {
            post: {},
            currentUrl: "",
            advertisements: {
                aboveSidebarAd_300_600: null,
                belowSidebarAd_300_600: null,
                garminAd300x600: 'https://hrgde.adocean.pl/_' + (new Date()).getTime() + '/ad.js?id=fd7rqcOZiCK7dqmDdZvU1VN20sMqID3ZlMZgKzBZl.P.j7/nc=0/gdpr=0/gdpr_consent=/redir=',
                garminAd728x90: 'https://hrgde.adocean.pl/_' + (new Date()).getTime() + '/ad.js?id=9io6hGOJky3ajlfKaELFGhgJ4jcovN5.4fMAMaBwRfX.d7/nc=0/gdpr=0/gdpr_consent=/redir='
            },
            advertisementTypes: {
                SIDEBAR_UP_300_600: 11,
                SIDEBAR_DOWN_300_600: 10,
            }
        }
    },
    created() {
        this.fetchData();
        this.currentUrl = window.location.href;
    },
    mounted() {
        window.scrollTo(0, 0);
        if (typeof (FB) != 'undefined' && FB != null) {
            FB.XFBML.parse();
        }
        else {
            window.fbAsyncInit = function () {
                FB.init();
            };
        }

        var vueInstance = this;
        setTimeout(() => {
            postscribe('#garminAboveAd300x600', "<script src=" + vueInstance.advertisements.garminAd300x600 + "><\/script>");
            postscribe('#garminAboveAd728x90', "<script src=" + vueInstance.advertisements.garminAd728x90 + "><\/script>");
            postscribe('#garminBelowAd728x90', "<script src=" + vueInstance.advertisements.garminAd728x90 + "><\/script>");
        }, 1000);
    },
    methods: {
        fetchData: function () {
            var params = this.$route.params;
            NewsService.details(params.id)
                .then(res => {
                    this.post = res.data;
                    var paragraphsCount = this.getSubstringOccurrencies(this.post.content, "</p>");
                    var googleAdInsertionIndex = this.getNthIndexOfSubstringOccurrence(this.post.content, "</p>", paragraphsCount / 2) + 4;
                    this.post.content1 = this.post.content.substring(0, googleAdInsertionIndex);
                    this.post.content2 = this.post.content.substring(googleAdInsertionIndex);
                });
            AdvertisementsService.getActive().then(res => {
                var ads = res.data;
                var updateImpressionsForAdIds = [];
                this.advertisements.aboveSidebarAd_300_600 = ads.filter(a => a.advertisementTypeID === this.advertisementTypes.SIDEBAR_UP_300_600)[Math.floor(Math.random() * ads.filter(a => a.advertisementTypeID === this.advertisementTypes.SIDEBAR_UP_300_600).length)];
                if (this.advertisements.aboveSidebarAd_300_600)
                    updateImpressionsForAdIds.push(this.advertisements.aboveSidebarAd_300_600.advertisementID);
                this.advertisements.belowSidebarAd_300_600 = ads.filter(a => a.advertisementTypeID === this.advertisementTypes.SIDEBAR_DOWN_300_600)[Math.floor(Math.random() * ads.filter(a => a.advertisementTypeID === this.advertisementTypes.SIDEBAR_DOWN_300_600).length)];
                if (this.advertisements.belowSidebarAd_300_600)
                    updateImpressionsForAdIds.push(this.advertisements.belowSidebarAd_300_600.advertisementID);
                AdvertisementsService.updateImpressions(updateImpressionsForAdIds).then(res => { });
            });
        },
        showOrHideFractions: function () {
            if (this.post.multimediaFiles && this.post.multimediaFiles.length < 2)
                document.getElementsByClassName("vueperslides__fractions")[0].style.display = "none";
        },
        enlargePhoto: function (index) {
            this.$refs.lightbox.showImage(index);
        },
        getSubstringOccurrencies(string, subString, allowOverlapping) {
            string += "";
            subString += "";
            if (subString.length <= 0) return (string.length + 1);

            var n = 0,
                pos = 0,
                step = allowOverlapping ? 1 : subString.length;

            while (true) {
                pos = string.indexOf(subString, pos);
                if (pos >= 0) {
                    ++n;
                    pos += step;
                } else break;
            }
            return n;
        },
        getNthIndexOfSubstringOccurrence(str, subStr, i) {
            if (str)
                return str.split(subStr, i).join(subStr).length;
            return -1;
        },
        updateAdvertisementClicks(advertisementID) {
            AdvertisementsService.updateClicks(advertisementID).then(res => { });
        }
    }
}
</script>

<style scoped>
.posts-list.has-style-1 .post-item {
    flex: 0 0 33.33%;
    -webkit-flex: 0 0 33.33%;
    -ms-flex: 0 0 33.33%;
}

.vueperslides__bullet .default {
    color: white;
}

.m-post-content .post-share,
.m-post-content .post-share-alt,
.m-post-content .post-tags,
.m-post-content .post-tags-alt {
    margin-bottom: 20px;
}

.style-1 .widget.social {
    margin-bottom: 20px;
}

.style-1 .widget.social ul li a {
    color: #ffffff;
    border-radius: 3px;
}

.headline {
    display: inline-block;
    text-transform: uppercase;
}

.vueperslide {
    background-size: contain;
    background-repeat: no-repeat;
}

.vueperslides__arrow {
    color: lightgray;
}

.categories {
    display: inline-block;
    margin-right: 7px;
}

.social--color .social__whatsapp {
    background-color: #075e54;
}

.social--color .social__viber {
    background-color: #665CAC;
}

.videoWrapper {
    position: relative;
    padding-bottom: 56.25%;
    margin-bottom: 25px;
}

.videoWrapper>>>iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.full-screen {
    cursor: pointer;
    height: 100%;
}

.mobile {
    display: block;
}

.audioWrapper audio {
    width: 100%;
}

.category-line {
    opacity: 0.3;
    margin: 0px;
}

.ad-728-90-above {
    margin-top: -20px;
    margin-bottom: 20px;
    text-align: center;
}

.ad-728-90-below {
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
}

.ad-300-250-sidebar-above,
.ad-300-600-sidebar-above {
    text-align: center;
    margin-bottom: 40px;
}

.ad-300-250-sidebar-below,
.ad-300-600-sidebar-below {
    text-align: center;
    margin-top: 40px;
}

.m-post-content--nyc .post-top .post-meta .item {
    margin-right: 15px;
}

@media only screen and (min-width: 767px) {
    .mobile {
        display: none;
    }
}

.m-post-content .post-tags .tags-wrap a {
    margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Details.vue